// src/context/LoadsContext.jsx
import React, { createContext, useContext, useState } from 'react';

const LoadsContext = createContext();

/** Wrap your app in this provider */
export function LoadsProvider({ children }) {
  const [loads, setLoads] = useState([]);
  return (
    <LoadsContext.Provider value={{ loads, setLoads }}>
      {children}
    </LoadsContext.Provider>
  );
}

/** Hook for easy access */
export function useLoads() {
  const ctx = useContext(LoadsContext);
  if (!ctx) {
    throw new Error('useLoads must be inside LoadsProvider');
  }
  return ctx;
}
